module.exports = "/fonts/fa-solid-900.eot?a0369ea57eb6d3843d6474c035111f29";